export default __webpack_public_path__ + "static/data-more-about-img--mobile-45db1361ea99922cb5f5c6f31492de06.png";